import update from 'immutability-helper';
import {
  API_REDEMPTION_FETCH,
  API_REDEMPTION_FETCH_SUCCESS,
  API_REDEMPTION_APPROVE_REQUEST,
  API_REDEMPTION_APPROVE_SUCCESS,
  API_REDEMPTION_REJECT_REQUEST,
  API_REDEMPTION_REJECT_SUCCESS,
  API_REDEMPTION_FETCH_ERROR,
} from '../actions/types';
import {createReducer} from '../utils';
import {
  redemptionApprovedMessage,
  redemptionLoadingError,
  redemptionRejectedMessage,
} from '../configs/messages';

const initialState = {
  isRedemptionFetching: false,
  isRedemptionProcessing: false,
  requester: null,
  treasure: null,
  result: '',
};

const treasureReducer = createReducer(initialState, {
  [API_REDEMPTION_FETCH]: state => update(state, {
    isRedemptionFetching: {$set: true},
  }),
  [API_REDEMPTION_FETCH_SUCCESS]: (state, payload) => {
    const {response: {requester, treasure}} = payload;

    return update(state, {
      isRedemptionFetching: {$set: false},
      requester: {$set: requester},
      treasure: {$set: treasure},
    });
  },
  [API_REDEMPTION_FETCH_ERROR]: (state, payload) => {
    const {error} = payload;
    const result = error === 'Unknown' ? redemptionLoadingError : error;

    return update(state, {
      isRedemptionFetching: {$set: false},
      result: {$set: result},
    });
  },
  [API_REDEMPTION_APPROVE_REQUEST]: state => update(state, {
    isRedemptionProcessing: {$set: true},
  }),
  [API_REDEMPTION_APPROVE_SUCCESS]: state => update(state, {
    isRedemptionProcessing: {$set: false},
    result: {$set: redemptionApprovedMessage},
  }),
  [API_REDEMPTION_REJECT_REQUEST]: state => update(state, {
    isRedemptionProcessing: {$set: true},
  }),
  [API_REDEMPTION_REJECT_SUCCESS]: state => update(state, {
    isRedemptionProcessing: {$set: false},
    result: {$set: redemptionRejectedMessage},
  }),
});

export default treasureReducer;
